import { createReducer } from 'utils';
import types from './types';

const initialState = { open: false, httpError: undefined };

const ErrorDialog = createReducer(initialState, {
  [types.SHOW_ERROR]: (state, action) => ({
    open: true,
    httpError: action.payload,
  }),
  [types.CLOSE_ERROR]: state => ({
    ...initialState,
  }),
});

export default {
  ErrorDialog,
};
